import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as React from "react";
import {useContext, useEffect, useState} from "react";
import { Box, Card, CardContent, Grid, Stack, Typography } from "@mui/material";
import ReportPreviewTable from "../tables/ReportPreviewTable";
import {ArrowBackRounded, InfoRounded} from "@mui/icons-material";
import ReportPreviewFilter from "../filters/ReportPreviewFilter";
import SectionHeader from "../../../../../util/component/SectionHeader";
import { useIntermediariesReportRepository } from "../../../api/repositories/IntermediariesReportRepository";
import { getQuarterlyByKey } from "../tables/ReportTableUtil";
import {formatDate} from "../../../utils/FormatUtils";
import {useIntermediariesPrintoutRepository} from "../../../api/repositories/IntermediariesPrintoutRepository";
import {useRecoilValue} from "recoil";
import {STATE_PREVIEW_ACTIVE_FILTERS} from "../constants/IntermediariesRecoil";
import FinanceDialog from "../../../component/FinanceDialog";
import {setSnackbar} from "../../../../../util/state/globalAction";
import {snackbarTypes} from "../../../../../util/state/globalVariables";
import {GlobalContext} from "../../../../../util/state/GlobalContextProvider";

const ReportPreview = (props: any) => {
    const {t} = useTranslation('finance', {keyPrefix: 'intermediaries'});
    const {getReportById} = useIntermediariesReportRepository();
    const[data, setData] = useState<any>(null);
    const[printoutData, setPrintoutData] = useState<any>(null);
    const{id} = useParams();
    const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [publishable, setPublishable] = useState<any>({});
    const [publishableLength, setPublishableLength] = useState(0);
    const {getPrintoutsOfReport, publishIntermediaryPrintouts} = useIntermediariesPrintoutRepository();
    const filterDefs = useRecoilValue(STATE_PREVIEW_ACTIVE_FILTERS);
    const [totalElements, setTotalElements] = useState<any>(0);
    const { dispatchGlobalData } = useContext(GlobalContext);
    const onRowSelected = (id: string, isSelected: boolean, node: any) => {
        if (!isSelected) {
            delete publishable[id];
        } else {
            publishable[id] = node;
        }
    }

    useEffect(() => {
        getReportById(id!)
            .then(response => {
                let result = response.result;
                setData(result);
            });
        getPrintoutsOfReport( filterDefs, id)
            .then(response => {
                let result = response.result;
                setPrintoutData(result.content);
                setTotalElements(result.page.totalElements);
            })
    }, []);

    useEffect(() => {
        if (updating) {
            getPrintoutsOfReport( filterDefs, id)
                .then(response => {
                    let result = response.result;
                    setPrintoutData(result.content);
                    setTotalElements(result.page.totalElements);
                    setUpdating(false)
                })
        }
    }, [updating])

    const sendIntermediariesPrintouts = () => {
        publishIntermediaryPrintouts(Object.keys(publishable))
            .then(() => {
                setUpdating(true);
                dispatchGlobalData({
                    type: setSnackbar,
                    payload: {
                        snackbar: {
                            message: t('preview.email.success'),
                            type: snackbarTypes.success,
                            show: true,
                            autoClose: true
                        }
                    }
                });
            })
            .catch((error) => {
                console.error(error);
            })
            .finally(() => {
                setPublishable({});
                setPublishableLength(0);
            })
    }

    return (
        <Box>
            <SectionHeader title={t('header.title')} subtitle={t('header.subtitle')}/>
            <Card variant="outlined" sx={{margin: '15px'}}>
                <CardContent>
                    <Grid container direction={'column'} rowGap={2}>
                        <Grid item>
                            <Box style={{display: 'flex', alignItems: 'center', gap: '1ch', cursor: 'pointer'}}>
                                {/*<ArrowBackRounded />*/}
                                <Typography variant={'body1'} fontWeight={'bold'}>
                                    {t('preview.topLabel.key')}
                                </Typography>
                                <Typography variant={'body1'} fontWeight={'bold'}>
                                    {t('preview.topLabel.value', {year: data?.year, selectedQuarter: getQuarterlyByKey(data?.quarterly)})}
                                </Typography>

                            </Box>
                        </Grid>
                        <Stack direction={"column"} spacing={2} margin={"16px"}>
                            <ReportPreviewFilter setUpdating={setUpdating}/>
                            <ReportPreviewTable data={printoutData} selectedDataLength={publishableLength} setSelectedDataLength={setPublishableLength}
                                                setUpdating={setUpdating}
                                                onRowSelected={onRowSelected}
                                                onPublishClick={() => setOpenConfirmationModal(true)}/>

                        </Stack>
                    </Grid>
                </CardContent>
                <FinanceDialog title={t('preview.email.title')}
                               content={t('preview.email.content', { selectedRecharges: publishableLength })}
                               open={openConfirmationModal}
                               onClose={() => setOpenConfirmationModal(false)}
                               callback={sendIntermediariesPrintouts}
                               cancelButton={t('preview.email.cancel')}
                               confirmButton={t('preview.email.confirm')}
                               titleIcon={<InfoRounded/>}/>
            </Card>
        </Box>
    );
}

export default ReportPreview;